export const SEODataNames = {
  CANONICAL_URL: 'pageCanonicalUrl',
  PAGE_META_DESCRIPTION: 'pageMetaDescription',
  PAGE_META_ROBOTS: 'pageMetaRobotsTag',
  PAGE_TITLE: 'pageTitleTag',
  SCHEMA_ORG: 'pageSchemaOrgJsonLdData',
  OG_TWITTER_IMAGE: 'ogtwitterImage',
}
